export enum DeviceEnum {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP'
}

const MIN_WINDOW_WIDTH = 768;

export function getGlobalState() {
  const device = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? 'MOBILE' : 'DESKTOP';
  const isMobile = device === DeviceEnum.MOBILE || window.innerWidth <= MIN_WINDOW_WIDTH;

  return {
    device,
    isMobile
  } as { device: DeviceEnum; collapsed: boolean; isMobile: boolean };
}
